const Homi = () => {
    return (
      <div className="relative w-full h-[64rem] text-left text-[0.88rem] text-white font-text-xs-font-medium">
        <div className="absolute top-[0rem] left-[0rem] bg-black w-[90rem] h-[64rem] overflow-hidden">
          <img
            className="absolute top-[0rem] left-[0rem] w-[90rem] h-[64rem] object-cover"
            alt=""
            src="/image-3@2x.png"
          />
          <div className="absolute top-[2.69rem] left-[24.5rem] rounded-48xl box-border w-[44.75rem] h-[3.31rem] overflow-hidden text-[1.13rem] border-[1px] border-solid border-white">
            <div className="absolute top-[1rem] left-[3.88rem] opacity-[0.41]">
              Search
            </div>
            <img
              className="absolute top-[1.13rem] left-[1.94rem] w-[1.25rem] h-[1.25rem] overflow-hidden"
              alt=""
              src="/uilsearch.svg"
            />
          </div>
          <div className="absolute top-[11.44rem] left-[20.31rem] rounded-48xl [background:linear-gradient(95.28deg,_rgba(149,_175,_214,_0.61),_rgba(255,_255,_255,_0))] box-border w-[11.13rem] h-[3.31rem] overflow-hidden text-[1.13rem] border-[1px] border-solid border-white">
            <div className="absolute top-[1rem] left-[2rem]">Create a post</div>
          </div>
          <div className="absolute top-[8.16rem] left-[18.78rem] bg-teal-300 box-border w-[0.06rem] h-[55.88rem] opacity-[0.48] border-r-[1px] border-solid border-purple-200" />
          <div className="absolute top-[8.16rem] left-[71.34rem] bg-teal-300 box-border w-[0.06rem] h-[55.88rem] opacity-[0.48] border-r-[1px] border-solid border-purple-200" />
          <div className="absolute top-[8.16rem] left-[-0.03rem] bg-teal-300 box-border w-[90.06rem] h-[0.06rem] opacity-[0.48] border-t-[1px] border-solid border-purple-200" />
          <div className="absolute top-[9.75rem] left-[72.56rem] rounded-lg bg-white w-[16.25rem] h-[14.31rem] overflow-hidden opacity-[0.21]" />
          <div className="absolute top-[26.19rem] left-[72.56rem] rounded-lg bg-white w-[16.25rem] h-[25.13rem] overflow-hidden opacity-[0.23]" />
          <div className="absolute top-[27.44rem] left-[1.19rem] rounded-lg bg-white w-[16.44rem] h-[14rem] overflow-hidden opacity-[0.23]" />
          <img
            className="absolute top-[30.44rem] left-[73.94rem] rounded-8xl w-[2rem] h-[2rem] object-cover"
            alt=""
            src="/avatar@2x.png"
          />
          <img
            className="absolute top-[33.88rem] left-[73.94rem] rounded-8xl w-[2rem] h-[2rem] object-cover"
            alt=""
            src="/avatar@2x.png"
          />
          <img
            className="absolute top-[37.31rem] left-[73.94rem] rounded-8xl w-[2rem] h-[2rem] object-cover"
            alt=""
            src="/avatar@2x.png"
          />
          <img
            className="absolute top-[40.75rem] left-[73.94rem] rounded-8xl w-[2rem] h-[2rem] object-cover"
            alt=""
            src="/avatar@2x.png"
          />
          <img
            className="absolute top-[44.19rem] left-[73.94rem] rounded-8xl w-[2rem] h-[2rem] object-cover"
            alt=""
            src="/avatar@2x.png"
          />
          <div className="absolute top-[27.56rem] left-[75.63rem] text-[1rem]">
            Popular Communities
          </div>
          <div className="absolute top-[47.88rem] left-[78.13rem] rounded-md bg-black opacity-[0.27]" />
          <div className="absolute top-[48rem] left-[78.75rem] text-[0.75rem] leading-[150%] font-medium text-center">
            Load More
          </div>
          <div className="absolute top-[30.19rem] left-[6.13rem] text-[1rem]">
            Today’s Tasks
          </div>
          <div className="absolute top-[30.44rem] left-[76.56rem]">
            IndiaweIndian
          </div>
          <div className="absolute top-[33.88rem] left-[76.56rem]">
            IndiaweIndian
          </div>
          <div className="absolute top-[37.31rem] left-[76.56rem]">
            IndiaweIndian
          </div>
          <div className="absolute top-[40.75rem] left-[76.56rem]">
            IndiaweIndian
          </div>
          <div className="absolute top-[44.19rem] left-[76.56rem]">
            IndiaweIndian
          </div>
          <div className="absolute top-[31.69rem] left-[76.63rem] text-[0.63rem]">
            500 members
          </div>
          <div className="absolute top-[35.13rem] left-[76.63rem] text-[0.63rem]">
            500 members
          </div>
          <div className="absolute top-[38.56rem] left-[76.63rem] text-[0.63rem]">
            500 members
          </div>
          <div className="absolute top-[42rem] left-[76.63rem] text-[0.63rem]">
            500 members
          </div>
          <div className="absolute top-[45.44rem] left-[76.63rem] text-[0.63rem]">
            500 members
          </div>
          <div className="absolute top-[10.38rem] left-[83.63rem] rounded-24xl box-border w-[4.63rem] h-[1.63rem] overflow-hidden text-[0.75rem] border-[1px] border-solid border-white">
            <div className="absolute top-[0.31rem] left-[1.13rem] font-medium">
              Buy
            </div>
            <img
              className="absolute h-[32.69%] w-[11.49%] top-[35.58%] right-[19.26%] bottom-[31.73%] left-[69.26%] max-w-full overflow-hidden max-h-full"
              alt=""
              src="/icon.svg"
            />
          </div>
          <div className="absolute top-[21rem] left-[77.44rem] rounded-24xl box-border w-[6.44rem] h-[1.63rem] overflow-hidden text-[0.75rem] border-[1px] border-solid border-white">
            <div className="absolute top-[0.31rem] left-[1.13rem] font-medium">
              100 Socoins
            </div>
          </div>
          <img
            className="absolute top-[10.19rem] left-[1.19rem] rounded-lg w-[16.44rem] h-[15.5rem] overflow-hidden opacity-[0.21]"
            alt=""
            src="/frame-5.svg"
          />
          <div className="absolute top-[16.94rem] left-[20.19rem] rounded-lg bg-white w-[50rem] h-[40.88rem] overflow-hidden opacity-[0.21]">
            <img
              className="absolute top-[38.44rem] left-[157.94rem] w-[1.5rem] h-[1.5rem] overflow-hidden"
              alt=""
              src="/thumbsup.svg"
            />
            <div className="absolute top-[37.38rem] left-[11.44rem] w-[1.5rem] h-[1.5rem] overflow-hidden" />
            <div className="absolute top-[38.44rem] left-[5.19rem] font-medium">
              451
            </div>
          </div>
          <div className="absolute top-[53rem] left-[30.31rem] rounded-smi bg-white box-border w-[6.06rem] h-[2.38rem] overflow-hidden opacity-[0.24] border-[1px] border-solid border-white" />
          <img
            className="absolute top-[17.75rem] left-[20.94rem] rounded-8xl w-[2rem] h-[2rem] object-cover"
            alt=""
            src="/avatar@2x.png"
          />
          <div className="absolute top-[53.44rem] left-[23.69rem] w-[5.31rem] h-[1.5rem]">
            <div className="absolute top-[0.25rem] left-[8.19rem] flex flex-row items-start justify-start gap-[0.63rem]">
              <img
                className="relative w-[1.25rem] h-[1.25rem]"
                alt=""
                src="/vector.svg"
              />
              <div className="relative font-medium">21</div>
            </div>
            <img
              className="absolute top-[-0.12rem] left-[-0.75rem] w-[1.5rem] h-[1.5rem] overflow-hidden"
              alt=""
              src="/thumbsup1.svg"
            />
            <div className="absolute top-[-0.44rem] left-[-1.87rem] rounded-smi bg-white overflow-hidden opacity-[0.24] border-[1px] border-solid border-white" />
            <div className="absolute top-[-0.37rem] left-[35.38rem] rounded-smi bg-white w-[8.31rem] h-[2.56rem] overflow-hidden opacity-[0.24]" />
            <img
              className="absolute top-[-35.62rem] left-[39.81rem] rounded-smi w-[5.19rem] h-[1.88rem] overflow-hidden"
              alt=""
              src="/frame-13924.svg"
            />
            <div className="absolute top-[-35.25rem] left-[40.69rem] text-[0.75rem] leading-[150%] font-medium text-center">
              Follow
            </div>
            <img
              className="absolute top-[0.06rem] left-[41.75rem] w-[1.5rem] h-[1.56rem] object-cover"
              alt=""
              src="/3-d-glassmorphism-crypto-initial-coin-offerings-announcement-instagram-post-1@2x.png"
            />
            <div className="absolute top-[0.25rem] left-[37rem] text-[1rem] font-semibold">
              Tip User
            </div>
            <div className="absolute top-[0.19rem] left-[1rem] font-medium">
              451
            </div>
            <img
              className="absolute top-[0rem] left-[3rem] w-[1.5rem] h-[1.5rem] overflow-hidden"
              alt=""
              src="/thumbsup2.svg"
            />
          </div>
          <img
            className="absolute top-[12rem] left-[76.44rem] w-[8.5rem] h-[9rem] object-cover"
            alt=""
            src="/3-d-glassmorphism-crypto-initial-coin-offerings-announcement-instagram-post-11@2x.png"
          />
          <div className="absolute top-[13.44rem] left-[4.25rem] w-[3.88rem] h-[1.06rem] text-center text-[0.75rem] text-gray-900">
            <img
              className="absolute top-[11.88rem] left-[17.69rem] rounded-8xl w-[45.31rem] h-[25.56rem] object-cover"
              alt=""
              src="/image-5@2x.png"
            />
            <div className="absolute top-[9.31rem] left-[27.31rem] rounded-md bg-green-300 flex flex-row items-center justify-center py-[0.13rem] px-[0.63rem]">
              <div className="relative leading-[150%] font-medium">#FAQ</div>
            </div>
            <div className="absolute top-[9.31rem] left-[17.06rem] rounded-md bg-yellow-300 flex flex-row items-center justify-center py-[0.13rem] px-[0.63rem]">
              <div className="relative leading-[150%] font-medium">#India</div>
            </div>
            <div className="absolute top-[9.31rem] left-[21.69rem] rounded-md bg-red-300 flex flex-row items-center justify-center py-[0.13rem] px-[0.63rem]">
              <div className="relative leading-[150%] font-medium">#Opinion</div>
            </div>
            <img
              className="absolute h-[64.71%] w-[20.97%] top-[17.65%] right-[79.03%] bottom-[17.65%] left-[0%] max-w-full overflow-hidden max-h-full"
              alt=""
              src="/vector1.svg"
            />
            <div className="absolute top-[0rem] left-[1.38rem] text-[0.88rem] text-white text-left">{`Home `}</div>
            <div className="absolute top-[4.56rem] left-[19.25rem] text-[1rem] font-medium text-white text-left">
              ratr/451
            </div>
            <img
              className="absolute top-[3.56rem] left-[9rem] w-[1.5rem] h-[1.5rem] overflow-hidden"
              alt=""
              src="/gridiconsdropdown.svg"
            />
            <img
              className="absolute top-[7.19rem] left-[9rem] w-[1.5rem] h-[1.5rem] overflow-hidden"
              alt=""
              src="/gridiconsdropdown.svg"
            />
          </div>
          <div className="absolute top-[17.13rem] left-[4.25rem] w-[8.88rem] h-[1.06rem]">
            <img
              className="absolute h-[35.29%] w-[9.15%] top-[35.29%] right-[90.85%] bottom-[29.41%] left-[0%] max-w-full overflow-hidden max-h-full"
              alt=""
              src="/vector2.svg"
            />
            <div className="absolute top-[0rem] left-[1.38rem]">
              Trending Creators
            </div>
          </div>
          <div className="absolute top-[20.81rem] left-[4.25rem] w-[7.5rem] h-[1.06rem]">
            <img
              className="absolute h-[47.06%] w-[8.33%] top-[29.41%] right-[91.67%] bottom-[23.53%] left-[0%] max-w-full overflow-hidden max-h-full"
              alt=""
              src="/vector3.svg"
            />
            <div className="absolute top-[0rem] left-[1.31rem]">
              Trending Posts
            </div>
          </div>
          <div className="absolute top-[33.31rem] left-[2.13rem] rounded-6xs bg-white w-[14.5rem] h-[1.75rem] overflow-hidden text-gray-900">
            <div className="absolute top-[0.31rem] left-[0.88rem]">
              Complete one upvote
            </div>
            <img
              className="absolute top-[0.44rem] left-[12.63rem] w-[0.94rem] h-[0.94rem] overflow-hidden"
              alt=""
              src="/teenyiconstickcircleoutline.svg"
            />
          </div>
          <div className="absolute top-[36.5rem] left-[2.13rem] rounded-6xs bg-white w-[14.5rem] h-[1.75rem] overflow-hidden text-gray-900">
            <div className="absolute top-[0.31rem] left-[0.88rem]">
              Complete 10 comments
            </div>
            <img
              className="absolute top-[0.44rem] left-[12.56rem] w-[0.94rem] h-[0.94rem] overflow-hidden"
              alt=""
              src="/teenyiconstickcircleoutline.svg"
            />
          </div>
          <div className="absolute top-[2.69rem] left-[74.94rem] rounded-48xl bg-colours-blue-gray-900 box-border w-[12.19rem] h-[3.31rem] overflow-hidden flex flex-row items-center justify-center py-[1.13rem] px-[1.44rem] gap-[0.5rem] border-[1px] border-solid border-white">
            <div className="relative font-medium">Connect to wallet</div>
            <img
              className="relative w-[1.5rem] h-[1.5rem] overflow-hidden shrink-0"
              alt=""
              src="/gridiconsdropdown1.svg"
            />
          </div>
        </div>
        <b className="absolute top-[20.13rem] left-[21.25rem] text-[1.5rem]">
          What unpopular opinion on India will have you like this?
        </b>
      </div>
    );
  };
  
  export default Homi;
  